import { JurisdictionApi } from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getJurisdictionCreationObject } from "../Data/JurisdictionWrappers";

export const updateJurisdictionApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${JurisdictionApi}/${id}`,
      getJurisdictionCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further Jurisdiction if needed
  }
};
